export const getPartnersPageItemListData = () => {
  const searchContentTag = document.getElementById('searchContent');

  if (searchContentTag != null) {
    const itemListId = searchContentTag?.dataset?.item_list_id
      ?.toLowerCase()
      ?.replaceAll(' ', '_');
    const itemListName = searchContentTag?.dataset?.item_list_name;
    return {
      itemListId: itemListId ?? 'catalog_all_products',
      itemListName: itemListName ?? 'Catalog',
    };
  }

  return { itemListId: 'catalog_all_products', itemListName: 'Catalog' };
};
